import React from 'react';
import { useT } from 'i18n/hooks/useT';
import { useLocale } from 'client/i18n/hooks/useLocale';
import { MarketingImage } from 'components/MarketingPagesShared/MarketingImage';
import { Button } from 'shared/Button/NewButton';
import {
  SwitchHeroGrid,
  SwitchHeroGridImage,
  SwitchHeroGridImageReversedOnNarrow,
  SwitchHeroPrimary,
  SwitchHeroPrimaryText,
  SwitchHeroPrimaryImages,
  SwitchHeroSecondaryImages,
  SwitchHeroTitle,
  SwitchHeroSecondary,
  SwitchHeroSecondaryText,
} from './styles';

// There are localized assets for only some markets at the moment, but this list might grow in the future.
const marketsWithLocalizedAssets = ['es-LA', 'id', 'pt-BR'];

export function SwitchHeroSection({
  onSwitchButtonClick,
}: {
  onSwitchButtonClick?: () => void;
}) {
  const t = useT();
  const { locale } = useLocale();
  const assetsLocale = marketsWithLocalizedAssets.includes(locale)
    ? locale
    : 'en';

  return (
    <>
      <SwitchHeroPrimary>
        <SwitchHeroPrimaryText>
          <SwitchHeroTitle
            dangerouslySetInnerHTML={{
              __html: t(
                'ImportScreen.SwitchHeroSection.Title',
                'Powering <br /> the most podcasts worldwide',
                'Switch to Anchor page title'
              ),
            }}
          />
          <Button onClick={onSwitchButtonClick} color="onDark">
            {t(
              'ImportScreen.SwitchHeroSection.SwitchButtonLabel',
              'Switch in less than 5 minutes',
              'Switch your podcast to Anchor button text'
            )}
          </Button>
        </SwitchHeroPrimaryText>
        <SwitchHeroPrimaryImages>
          <SwitchHeroGrid>
            <SwitchHeroGridImage>
              <MarketingImage
                imagePath={`switch/hero/localized-assets/${assetsLocale}/cover-right-top`}
                alt={t(
                  'ImportScreen.SwitchHeroSection.PodcastCoverImageAlt',
                  'An image of a podcast cover',
                  'Switch to Anchor page podcast cover image screenreader information'
                )}
                width={260}
                height={260}
              />
            </SwitchHeroGridImage>
            <SwitchHeroGridImage>
              <MarketingImage
                imagePath={`switch/hero/localized-assets/${assetsLocale}/cover-right-middle`}
                alt={t(
                  'ImportScreen.SwitchHeroSection.PodcastCoverImageAlt',
                  'An image of a podcast cover',
                  'Switch to Anchor page podcast cover image screenreader information'
                )}
                width={260}
                height={260}
              />
            </SwitchHeroGridImage>
            <SwitchHeroGridImage>
              <MarketingImage
                imagePath={`switch/hero/localized-assets/${assetsLocale}/cover-right-bottom`}
                alt={t(
                  'ImportScreen.SwitchHeroSection.PodcastCoverImageAlt',
                  'An image of a podcast cover',
                  'Switch to Anchor page podcast cover image screenreader information'
                )}
                width={260}
                height={260}
              />
            </SwitchHeroGridImage>
          </SwitchHeroGrid>
        </SwitchHeroPrimaryImages>
      </SwitchHeroPrimary>
      <SwitchHeroSecondary>
        <SwitchHeroSecondaryImages>
          <SwitchHeroGrid>
            <SwitchHeroGridImageReversedOnNarrow>
              <MarketingImage
                imagePath={`switch/hero/localized-assets/${assetsLocale}/cover-left-top`}
                alt={t(
                  'ImportScreen.SwitchHeroSection.PodcastCoverImageAlt',
                  'An image of a podcast cover',
                  'Switch to Anchor page podcast cover image screenreader information'
                )}
                width={260}
                height={260}
              />
            </SwitchHeroGridImageReversedOnNarrow>
            <SwitchHeroGridImageReversedOnNarrow>
              <MarketingImage
                imagePath={`switch/hero/localized-assets/${assetsLocale}/cover-left-bottom`}
                alt={t(
                  'ImportScreen.SwitchHeroSection.PodcastCoverImageAlt',
                  'An image of a podcast cover',
                  'Switch to Anchor page podcast cover image screenreader information'
                )}
                width={260}
                height={260}
              />
            </SwitchHeroGridImageReversedOnNarrow>
          </SwitchHeroGrid>
        </SwitchHeroSecondaryImages>
        <SwitchHeroSecondaryText>
          {t(
            'ImportScreen.SwitchHeroSection.SwitchDescription',
            'With free hosting and tools for every experience level, 80% of new podcasts get created on Anchor. Switching is seamless—and free.',
            'Switch to Anchor page message'
          )}
        </SwitchHeroSecondaryText>
      </SwitchHeroSecondary>
    </>
  );
}
